/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from '../utils/axios'

// 获取一级路由
export const getRouters1 = function () {
    return axios.get('/menu/getMenu')
}

// 获取二级路由
export const getRouters2 = function (data: { id: number | null }) {
    return axios.post('/menu/getMenuById', data)
}

// 获取用户信息
export const getMyselfUser = function () {
    return axios.get('/user/getMyselfUser')
}

// 获取用户信息  // 2024-5-17 弃用
// export const getDepartmentByUserId = function(id: string) {
//     return axios.get('/finance/getDepartmentByUserId?userId=' + id)
// }

// 获取用户列表
export const getUserList = function (data?:
                                         {
                                             name?: string;
                                             types?: string;
                                             limit?: number;
                                             page?: number;
                                         }) {
    return axios.get('/user/getUserList', {params: data})
}

// 获取表头和设置表头
export const gettHeaderByType = function (types: number) {
    return axios.get('/market/getHeaderByType?types=' + types)
}
export const settHeaderByType = function (data: { headerIds: any[]; types: number }) {
    const headerIds = data.headerIds.map(item => ({ id: item.id, isShow: item.isShow }))
    return axios.post('/market/setHeaderByType', { headerIds, types: data.types })
}

// 上传文件
export const uploadFile = function (data: any) {
    return axios.post('/uploadFile', data)
}

// 获取当前登录账号在当前页面中的权限
export const getFunctionsByMenuName = function (data: { name: string }) {
    return axios.post('/user/getFunctionsByMenuName', data)
}

// 获取当前用户的导出列表
export const getDownloadList = function(data: { limit: number; page: number }) {
    return axios.get('/download/getDownloadList', { params: data })
}


// ------ 审批配置 ------
export const getDeparmentList = function (data?: { name?: string }) {
    return axios.get(`/review/getDepartmentList`, { params: data })
}
export const getReviewList = function (data: { limit: number; page: number; functionsLevel1Id: number; isDelete: boolean}) {
    return axios.post('/review/getReviewList', data)
}
export const getReviewById = function (data: { id: number }) {
    return axios.post('/review/getReviewById', data)
}
export const getFileByFunctionsId = function (data: { functionsId: number }) {
    return axios.post('/review/getFileByFunctionsId', data)
}
export const setReview = function (data: {
    id?: number;
    name: string;
    functionsLevel1Id: number;
    functionsLevel2Id: number;
    // isDelete: number;
    detail?: string;
    userIdList: string[];
    departmentIdList: number[];
    nodeObject: any;
}) {
    return axios.post('/review/setReview', data)
}
export const setIsDeleteById = function (data: { id: number; status: number }) {
    return axios.post('/review/setIsDeleteById', data)
}
// 删除审批
export const delReviewById = function(data: {id: number}) {
    return axios.post('/review/delReviewById', data)
}


// 获取可编辑字段
export const getEditFileByFunctionsId = function(functionId: number) {
    return axios.get('/review/getEditFileByFunctionsId?functionsId=' + functionId)
}

// ------ CRM消息 ------
export const getNotice = function (data: { limit: number; page: number }) {
    return axios.post('/notice/getNotice', data)
}
export const setNotice = function (data: { title: string; texts: string }) {
    return axios.post('/notice/setNotice', data)
}
export const delNotice = function (data: { id: number }) {
    return axios.delete('/notice/delNotice', { data })
}
export const getNoticeById = function (data: { id: number }) {
    return axios.post('/notice/getNoticeById', data)
}
export const setReadStatus = function (data: { id: number }) {
    return axios.post('/notice/setReadStatus', data)
}

// 市场运营 ------ 市场线索
export const setMarketClue = function (data: {
    name: string;
    sourceType: number | string;
    source: string;
    wechat: string;
    phone: string;
    other: string;
    grade: string;
    direction: string;
    remark: string;
    degree: string;
    directorUserId: string;
    status: number;
    receiverUserId: string;
    marketChannelId: string;
}) {
    return axios.post('/market/setMarketClue', data)
}
export const getMarketClue = function (data: {
    name: string;
    source: string[];
    directorUserId: string[];
    createUserId: string[];
    createdAt: string;
    wechat: string;
    status: number[];
    customerUserId: string;
    receiverUserId: string[];
    isSign: number;
    receiverAt: string;
    sourceType: string[];
    grade: string[];
    direction: string;
    degree: string[];
    eduTemandList: string[];
    level2Scourse: string;
    level2DepartmentId: number;
    level: string;
    page: number;
    limit: number;
}) { return axios.post('/market/getMarketClueList', data) }

export const getSource = function (data: { sourceType: number | string }) {
    return axios.post('/market/getSource', data)
}
export const duplicateCheck = function (data: { types: number; values: string; id?: number }) {
    return axios.post('/market/duplicateCheck', data)
}
export const getMarketClueById = function (data: { id: number }) {
    return axios.post('/market/getMarketClueById', data)
}
export const getMarketClueSource = function () {
    return axios.get('/market/getMarketClueSource')
}

export const getMarketClueSourceList = function (data: { source: string; page: number; limit: number }) {
    return axios.post('/market/getMarketClueSourceList', data)
}
export const setMarketClueById = function (data: {
    name: string;
    sourceType: number | string;
    source: string;
    wechat: string;
    phone: string;
    other: string;
    grade: string;
    direction: string;
    remark: string;
    degree: string;
    directorUserId: string;
    status: number;
    receiverUserId: string;
    id: number;
}) { return axios.post('/market/setMarketClueById', data) }

export const setMarketClueStatusReceiver = function (data: { idList: number[]; status: number; receiverUserId?: string }) {
    return axios.post('/market/setMarketClueStatusReceiver', data)
}
export const setMarketClueStatusInvalid = function (data: { idList: number[]; status: number;reason?: string }) {
    return axios.post('/market/setMarketClueStatusInvalid', data)
}
export const setMarketClueUser = function (data: { idList: number[]; types: number; userId?: string; sourceType?: number; source?: string }) {
    return axios.post('/market/setMarketClueUser', data)
}
export const getMarketClueStatisticalData = function (data: { timeType: number }) {
    return axios.post('/market/getMarketClueStatisticalData', data)
}
export const getMarketClueExportData = function (data: {
    name: string;
    source: string[];
    directorUserId: string[];
    createUserId: string[];
    createdAt: string;
    wechat: string;
    status: number[];
    receiverUserId: string[];
    isSign: number;
    receiverAt: string;
    sourceType: string[];
    grade: string[];
    direction: string;
    degree: string[];
    customerUserRealName: string;
    departmentIdList: number[];
    level: string;
    keys?: string;
}) { return axios.post('/market/marketClueExportData', data) }

 /*
 * 市场线索跟进记录*/
export const getCustomerConversionFollowList = function (
    data:
        {
            marketClueName?: string;
            marketClueSource?: string;
            customerConversionName?: string;
            userIdList?: string[];
            createdAt?: string;
            intentionality?: string;
            page?: number;
            limit?: number;
        }) {
    return axios.post('/market/getCustomerConversionFollowList', data)
}



/*
* 新增
* 市场线索回访*/
export const setMarketClueFollow = function (data: {idList: string[];stage: string; content: string}) {
    return axios.post('/market/setMarketClueFollow', data)
}
/*
* 线索回访记录*/
export const getMarketClueFollowList = function (data: { id: string; limit?: string; page?: string }) {
    return axios.get('/market/getMarketClueFollowList', {params: data})
}

/*线索回放记录统计报表*/
export const getMarketClueFollowStatisticalData = function (
    data:
        {
            marketClueName: string;
            createdAt: string;
            userIdList: object[];
            limit: number;
            page: number;
        }) {
    return axios.post('/market/getMarketClueFollowStatisticalData', data)
}

// 市场运营 -- 市场渠道
export const getMarketChannel = function (data: { page: number; limit: number; nameList: string[]; typeList: number[]; beginAt: string; directorUserIdList: string[] }) {
    return axios.post('/market/getMarketChannel', data)
}
export const setMarketChannel = function (data: { name: string; typeId: number | null; userId: string; beginAt: string }) {
    return axios.post('/market/setMarketChannel', data)
}
export const getMarketChannelById = function (id: number) {
    return axios.get('/market/getMarketChannelById?id=' + id)
}
export const setMarketChannelById = function (data: { id: number; name: string; typeId: number | null; userId: string; beginAt: string; remark: string }) {
    return axios.post('/market/setMarketChannelById', data)
}
export const getMarketChannelType = function () {
    return axios.get('/market/getMarketChannelType')
}
export const getMarketChannelName = function () {
    return axios.get('/market/getMarketChannelName')
}
export const getMarketChannelNameByTypeId = function (typeId: number) {
    return axios.get('/market/getMarketChannelNameByTypeId?typeId=' + typeId)
}
export const marketChannelExportData = function (data: { nameList: string[]; typeList: number[]; beginAt: string; directorUserIdList: string[] ; keys: string}) {
    return axios.post('/market/marketChannelExportData', data)
}
export const getMarketChannelStatisticalData = function (data: { timeStr: string; id?: number }) {
    return axios.post('/market/getMarketChannelStatisticalData', data)
}
export const delMarketChannelById = function (data: { id: number }) {
    return axios.delete('/market/delMarketChannelById', { data: data })
}


/*
* 获取渠道二维码*/
export const getMarketChannelQrcodeById = function (
    id: string
) {
    return axios.get('/market/getMarketChanneQrcodeById?id=' + id)
}

/*
*修改渠道统计状态 */
export const setMarketChanneIsUselById = function (
    data:
        {
            id: number;
            isUse: string;
        }
) {
    return axios.post('/market/setMarketChanneIsUselById', data)
}

// 市场运营 - 合作伙伴
export const setMarketCooperation = function (data: any) {
    return axios.post('/market/setMarketCooperation', data)
}

/*
* 传空的话就是获取全部的合作伙伴（在新建线索获取所有合作伙伴的时候使用）
* 传值就是筛选
* 修改接口（2022-8-9）
*/
export const getMarketCooperationPrevLevel = function (data?: { limit?: number; page?: number; name?: string; id?: number }) {
    return axios.post('/market/getMarketCooperationPrevLevel', data)
}

// 获取高校/分管具体来源列表
export const getMarketHighSchoolBranchCenterList = function (source: string) {
    return axios.get('/market/getMarketHighSchoolBranchCenterList?source=' + source)
}

// 获取合作伙伴详情
export const getMarketCooperationById = function (id: number, isUpdatedData: string) {
    return axios.get('/market/getMarketCooperationById?id=' + id + '&isUpdatedData=' + isUpdatedData)
}

export const getMarketCooperation = function (data: any) {
    return axios.post('/market/getMarketCooperation', data)
}
export const setMarketCooperationUser = function (data: { idList: number[]; userId: string }) {
    return axios.post('/market/setMarketCooperationUser', data)
}
export const marketCooperationExportData = function (data: any) {
    return axios.post('/market/marketCooperationExportData', data)
}
export const setMarketCooperationById = function (data: any) {
    return axios.post('/market/setMarketCooperationById', data)
}
//新增论文项目获取
export const getProjectDissertationList = function () {
    return axios.get('/market/getProjectDissertationList')
}

export const getMarketCooperationVisitByMarketCooperationId = function (
    data: {
        limit: number;
        page: number;
        marketCooperationId: number;
        visitAt?: string;
        userIdList?: object[];
    }) {
    return axios.post('/market/getMarketCooperationVisitByMarketCooperationId', data)
}
export const setMarketCooperationVisit = function (data: any) {
    return axios.post('/market/setMarketCooperationVisit', data)
}
export const duplicateCheckMarketCooperation = function (name: string) {
    return axios.post('/market/duplicateCheckMarketCooperation', { name })
}
// 市场运营-合作管理、合作伙伴统计数据
export const getMarketCooperationStatisticalData = function (data: { timeStr: string }) {
    return axios.post('/market/getMarketCooperationStatisticalData', data)
}
/*
* 渠道送生同比*/
export const getMarketCooperationContrast = function (
    data: {
        marketCooperationIdList: object[];
        firstTimeStr: string;
        secondTimeStr: string;
    }) {
    return axios.post('/market/getMarketCooperationContrast', data)
}
// 合作伙伴送生明细
export const getFinanceOrderListById = function (
    data: {
        id: number;
        createdAt: string;
        limit: number;
        page: number;
    }
) {
    return axios.get('/market/getFinanceOrderListById', {params: data})
}

// 删除合作伙伴
export const delMarketCooperationById = function (data: any) {
    return axios.post('/market/delMarketCooperationById', data)
}

// 学校列表
export const getSchoolList = function (data: any) {
    return axios.post('/tools/getSchoolList', data)
}
// 新建学校
export const setSchool = function (data: any) {
    return axios.post('/tools/setSchool', data)
}
// 编辑学校
export const setSchoolById = function (data: any) {
    return axios.post('/tools/setSchoolById', data)
}
// 删除学校
export const delSchoolByIdList = function (data: any) {
    return axios.delete('/tools/delSchoolByIdList', { data: data })
}
// 已报名学员
export const getCustmerListById = function (data: any) {
    return axios.post('/tools/getCustomerListById', data)
}
// 导出学校
export const schoolExportData = function (data: any) {
    return axios.post('/tools/schoolExportData', data)
}
// 便利工具-批量导入-获取表格模板
export const getTemplateByFunctionsId = function (functionsId: any) {
    return axios.get('/tools/getTemplateByFunctionsId?functionsId=' + functionsId)
}
// 便利工具-批量导入-导入模板数据
export const importTemplateData = function (data: any) {
    return axios.post('/tools/importTemplateData', data)
}

// 学生列表
export const getCustomerList = function (data: any) {
    return axios.post('/tools/getCustomerList', data)
}

// 学生列表导出
export const customerExportData = function (data: any) {
    return axios.post('/tools/customerExportData', data)
}

// 校验登陆
export const checkLogin = function () {
    return axios.get('/login/checkLogin')
}

// 获取验证码
export const getCode = function (phone: any) {
    return axios.get('/login/getCode?phone=' + phone)
}

// 登陆
export const loginCheckCode = function (data: any) {
    return axios.post('/login/checkCode', data)
}

// 退出登录
export const loginOut = function () {
    return axios.get('/login/loginOut')
}

/*
* 获取二维码识别号*/
export const getQrcode = function () {
    return axios.get('/login/getQrcode')
}

/*
* 获取扫码登录状态*/
export const checkQrcode = function (qrcode: any) {
    return axios.get('/login/checkQrcode?qrcode=' + qrcode)
}

/*
* 检测网申登录态
*/
export const checkApplyLogin = function () {
    return axios.get('/apply/checkApplyLogin')
}

/*
* 查询学生信息
* */

export const getCustomerInfo = function (data: any) {
    return axios.post('/apply/getCustomerInfo', data)
}

// 获取收款信息列表
export const payInfoList = function (data: { name?: string;  cardNum?: string; limit?: number; page?: number}) {
    return axios.post('/ekuaibao/payeeInfoList', data)
}

// 开户网点列表
export const getBranchList = function (data: { name: string; limit?: number; page?: number }) {
    return axios.post('/ekuaibao/getBranchList', data)
}



/*
* 合作伙伴 查看咨询记录*/
export const getMarketCooperationConsultByMarketCooperationId = function (
    data: {
        marketCooperationId: number;
        limit?: number;
        page?: number;
    }) {
    return axios.post('/market/getMarketCooperationConsultByMarketCooperationId', data)
}
/*
* 新增/编辑咨询
*/
export const setMarketCooperationConsult = function (
    data: {
        id?: number;
        marketCooperationId: number;
        marketCooperationAdviserId: number;
        address: string;
        price: string;
        consultAt: string;
        content: string;
        enclosureList?: object[];
    }) {
    return axios.post('/market/setMarketCooperationConsult', data)
}

/*
* */

export const getMarketCooperationAdviserList = function (
    data: {
        marketCooperationId: number;
    }) {
    return axios.get('/market/getMarketCooperationAdviserList', {params: data})
}


/*
* 导出咨询记录*/

export const getMarketCooperationConsultDataExport = function (
    data: {
        marketCooperationId: number;
    }) {
    return axios.post('/market/getMarketCooperationConsultDataExport', data)
}

/*
* 导出拜访记录*/
export const getMarketCooperationVisitDataExport = function (
    data: {
        marketCooperationId: number;
        userIdList: object[];
        visitAt: string;
    }) {
    return axios.post('/market/getMarketCooperationVisitDataExport', data)
}


/*
* 拜访记录统计报表
*/
export const getMarketCooperationVisitList = function (
    data: {
        marketCooperationName: string;
        userIdList: object[];
        visitAt: string;
        price: string;
        limit: number;
        page: number;
    }) {
    return axios.post('/market/getMarketCooperationVisitList', data)
}
/**
* 导出拜访记录统计报表
*/

export const getMarketCooperationVisitListDataExport = function (
    data: {
        marketCooperationName: string;
        userIdList: object[];
        visitAt: string;
        price: string;
        keys?: string;
    }) {
    return axios.post('/market/getMarketCooperationVisitListDataExport', data)
}

